import { MS_PER_SECOND } from './time';

export const NOTIFICATION_LIFESPAN_MS = MS_PER_SECOND * 7;
